export default __webpack_public_path__ + "static/media/register-bg.7a0b87d1.jpg";